import { DropdownOption } from 'components/IconDropdown/IconDropdown'

const allLanguages = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'Italian',
    value: 'it',
  },
]

export const contentLanguages = window.appConfig.CONTENT_LANGUAGES
  ? window.appConfig.CONTENT_LANGUAGES.split(',').map((language) =>
      language.trim()
    )
  : ['en']

const languages: DropdownOption[] = allLanguages.filter((language) =>
  window.appConfig.LANGUAGES && !window.Cypress
    ? window.appConfig.LANGUAGES.includes(language.value)
    : language
)

export default languages
